var map = {
	"./brown_5-6.png": "./src/assets/brown_5-6.png",
	"./green_5-6.png": "./src/assets/green_5-6.png",
	"./grey_5-6.png": "./src/assets/grey_5-6.png",
	"./red_5-6.png": "./src/assets/red_5-6.png",
	"./yellow_5-6.png": "./src/assets/yellow_5-6.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*_5\\-6\\.png$";